import React from 'react';
import step1 from '../../assets/img/servicearchitecture/1.png';
import step2 from '../../assets/img/servicearchitecture/2.png';
import step3 from '../../assets/img/servicearchitecture/3.png';
import step4 from '../../assets/img/servicearchitecture/4.png';

const CadDraftingProcess = () => {
    const steps = [
        {
            title: "Share Your Project Files",
            desc: "Upload sketches, PDFs, or requirements.",
            icon: step1
        },
        {
            title: "Initial Drafting",
            desc: "Our team creates the first 2D or 3D plan.",
            icon: step2
        },
        {
            title: "Review & Feedback",
            desc: "Collaborate to refine your project details.",
            icon: step3
        },
        {
            title: "Final Delivery",
            desc: "Receive accurate CAD files in your preferred format (DWG, PDF, STL).",
            icon: step4
        }
    ];

    return (
        <section className="cad-process-section">
            <div className="cad-process-header">
                <h2 className="cad-process-title">
                    <span className="text-primary">Our CAD</span> Drafting Process
                </h2>
                <p className="cad-process-subtitle">
                    We follow a simple, transparent, and client-focused workflow:
                </p>
            </div>

            <div className="cad-process-grid">
                {steps.map((item, index) => (
                    <div key={index} className="cad-process-card">
                        <div className="cad-process-icon-wrapper">
                            <img
                                src={item.icon.src || item.icon}
                                alt={item.title}
                            />
                        </div>
                        <h3 className="cad-process-card-title">{item.title}</h3>
                        <p className="cad-process-card-desc">{item.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default CadDraftingProcess;
